<template>
  <span class="balance-skeleton" :class="sizeClass">
    <span class="balance-skeleton__main"></span>
    <span class="balance-skeleton__sep">{{ separator }}</span>
    <span class="balance-skeleton__cents"></span>
    <span v-if="showSymbol" class="balance-skeleton__symbol">{{ symbol }}</span>
  </span>
</template>

<script>
export default {
  name: "BalanceSkeleton",
  props: {
    size: {
      type: String,
      default: "lg",
      validator: (value) => ["lg", "md", "sm"].includes(value),
    },
    separator: {
      type: String,
      default: ".",
    },
    symbol: {
      type: String,
      default: "",
    },
    showSymbol: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sizeClass() {
      return `balance-skeleton--${this.size}`
    },
  },
}
</script>

<style scoped>
.balance-skeleton {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.balance-skeleton__main,
.balance-skeleton__cents {
  display: inline-block;
  background: linear-gradient(
    90deg,
    var(--second-color) 25%,
    rgba(127, 127, 127, 0.18) 50%,
    var(--second-color) 75%
  );
  background-size: 200% 100%;
  animation: balance-skeleton-shimmer 1.5s infinite;
  border-radius: 6px;
  vertical-align: middle;
}

.balance-skeleton--lg .balance-skeleton__main {
  width: 110px;
  height: 32px;
}

.balance-skeleton--lg .balance-skeleton__cents {
  width: 40px;
  height: 32px;
  opacity: 0.75;
}

.balance-skeleton--md .balance-skeleton__main {
  width: 80px;
  height: 24px;
}

.balance-skeleton--md .balance-skeleton__cents {
  width: 32px;
  height: 24px;
  opacity: 0.75;
}

.balance-skeleton--sm .balance-skeleton__main {
  width: 60px;
  height: 18px;
}

.balance-skeleton--sm .balance-skeleton__cents {
  width: 24px;
  height: 18px;
  opacity: 0.75;
}

.balance-skeleton__sep {
  color: var(--text-color2);
  opacity: 0.4;
  line-height: 1;
}

.balance-skeleton__symbol {
  color: var(--text-color1);
  opacity: 0.3;
  margin-left: 4px;
}

@keyframes balance-skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
